export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/three_essentials_bg_active-6b958116515a0f3bf959ad3cc47e2909.svg";